import PageTab from './PageTab'

export default PageTab



// WEBPACK FOOTER //
// ./src/legacy/components/PageTab/index.js